import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

//firstControl / secondControl should give remainder 0
// NB only first field should show the error. The denominator can be any value
// and the error should appear in the multiplier field
export function remainderZeroValidator(
  firstControl: string,
  secondControl: string,
  msg: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const controlOne = control.get(firstControl).value;
    const controlTwo = control.get(secondControl).value;

    if (
      controlOne !== '' &&
      controlOne !== null &&
      controlTwo !== '' &&
      controlTwo !== null
    ) {
      if (Number(controlOne) % Number(controlTwo) !== 0) {
        control.get(firstControl).setErrors({ incorrect: true, message: msg });
        return { incorrect: true };
      }
    }

    control.get(firstControl).setErrors(null);
    control.get(secondControl).setErrors(null);
    return null;
  };
}
